// URL Base
const url_base = $("#infos").data("url-base");

// DEBOUNCE (Melhora a performance de funções repetitivas como "Scroll / Resize")
const debounce = function (n, t, u) {
  var e;
  return function () {
    var a = this,
      i = arguments,
      o = function () {
        (e = null), u || n.apply(a, i);
      },
      r = u && !e;
    clearTimeout(e), (e = setTimeout(o, t)), r && n.apply(a, i);
  };
};

// Verifica se o tamanho da tela é menor do que o tamanho passado (Útil em caso de verificação de responsividade)
function isMobileX(screenSize) {
  return $(window).width() < screenSize;
}

// Formata um valor para real (R$)
function formatMoneyBR(v, c, d, t) {
  var n = v,
    c = isNaN((c = Math.abs(c))) ? 2 : c,
    d = d == undefined ? "," : d,
    t = t == undefined ? "." : t,
    s = n < 0 ? "-" : "",
    i = parseInt((n = Math.abs(+n || 0).toFixed(c))) + "",
    j = (j = i.length) > 3 ? j % 3 : 0;
  return (
    s +
    (j ? i.substr(0, j) + t : "") +
    i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) +
    (c
      ? d +
        Math.abs(n - i)
          .toFixed(c)
          .slice(2)
      : "")
  );
}

// Formata um valor em real (R$) para o formato do banco
function formatMoneyBD(value) {
  return value.replace(".", "").replace(",", ".");
}

// Copia uma string para a área de transferência
function copyToClipboard(str) {
  const el = document.createElement("textarea");
  el.value = str;
  el.setAttribute("readonly", "");
  el.style.position = "absolute";
  el.style.left = "-9999px";
  document.body.appendChild(el);
  const selected =
    document.getSelection().rangeCount > 0
      ? document.getSelection().getRangeAt(0)
      : false;
  el.select();
  document.execCommand("copy");
  document.body.removeChild(el);
  if (selected) {
    document.getSelection().removeAllRanges();
    document.getSelection().addRange(selected);
  }
}

// Gera um slug
function slugify(text) {
  return text
    .toString()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[^\w-]+/g, "")
    .replace(/--+/g, "-");
}

// Lazy load
window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.loadMode = 1;

// ------------------------------------
// Campos dinâmicos
// ------------------------------------
(function () {
  "use strict";

  // Desativa o cache do Ajax
  $.ajaxSetup({ cache: false });

  // Campos dinâmicos
  $("[data-sync-input]").each(function () {
    // Variáveis

    // Campo dinâmico
    const $input = $(this);
    // Campo relativo
    const $relativeInput = $($input.data("sync-input"));
    // Parâmetro do campo relativo
    const parentParam = $input.data("sync-param");
    // URL da ação
    let url = `${$input.data("sync-url")}?${parentParam}=`;
    // Valor cadastrado do campo dinâmico (Update)
    let inputValue = $input.data("sync-value");
    // Parâmetro que ficará no atributo "value" de cada "<option>"
    const optionValue = $input.data("sync-option-value");
    // Parâmetro que ficará dentro de cada "<option>"
    const optionText = $input.data("sync-option-text");
    // Placeholder exibido no campo dinâmico, após o carregamento
    const inputPlaceholder = $input.data("sync-placeholder");

    // Carrega o campo dinâmico ao carregar a página
    loadSyncInput();

    // Evento de alteração do campo relativo
    $relativeInput.on("change", loadSyncInput);

    // Carrega o campo dinâmico
    function loadSyncInput() {
      processingSync();
      // Realiza a requisição dos dados
      $.getJSON(`${url}${$relativeInput.val()}`, function (result) {
        console.log(result);
        if (Array.isArray(result) && result.length > 0) {
          populateInput(result);
        } else {
          resetInput();
        }
        //input.trigger('change');
      }).fail(errorInput);
    }

    // Popula o campo dinâmico com os dados retornados
    function populateInput(list) {
      $input.html("");
      changePlaceholder(inputPlaceholder);
      inputValue = $input.data("sync-value");
      for (let i = 0, n = list.length; i < n; i++) {
        const selected = inputValue == list[i][optionValue] ? "selected" : "";
        $input.append(
          `<option value="${list[i][optionValue]}" ${selected}>${list[i][optionText]}</option>`
        );
      }
      $input.prop("disabled", false);
      if (inputValue != "") {
        $input.trigger("change");
        $input.parsley().validate();
      }
    }

    // Ações executadas enquanto a requisição é processada
    function processingSync() {
      $input.prop("disabled", true);
      $input.html("");
      changePlaceholder("Aguarde...");
    }

    // Reseta o campo dinâmico
    function resetInput() {
      $input.html("");
      changePlaceholder(inputPlaceholder);
      $input.prop("disabled", false);
    }

    // Erro na requisição
    function errorInput(resp) {
      console.log(resp);
      resetInput();
    }

    // Altera o placeholder do campo dinâmico
    function changePlaceholder(text) {
      // Select2
      if ($input.hasClass("select2")) {
        $input.append(`<option></option>`);
        setTimeout(() => {
          $(
            `#select2-${$input.attr(
              "id"
            )}-container .select2-selection__placeholder`
          ).text(text);
        });
      }
      // Select Padrão
      else {
        $input.append(`<option value="" hidden>${text}</option>`);
      }
    }
  });
})();
